import {SuelosActions, SuelosActionTypes} from './suelos.actions';
import {initialState, suelosAdapter, SuelosState} from './suelos.state';

export function suelosReducer(
  state = initialState,
  action: SuelosActions
): SuelosState {
  switch (action.type) {
    // load
    case SuelosActionTypes.SUELOS_LOAD_REQUEST: {
      return {
        ...state,
        isLoading: true,
        error: null
      };
    }
    case SuelosActionTypes.SUELOS_LOAD_SUCCESS: {
      return suelosAdapter.addMany(action.payload.items, {
        ...state,
        isLoading: false,
        error: null
      });
    }
    case SuelosActionTypes.SUELOS_LOAD_FAILURE: {
      return {
        ...state,
        isLoading: false,
        error: action.payload.error
      };
    }
    // default
    default: {
      return state;
    }
  }
}
